import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Container, Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Image } from "react-bootstrap";
import Preview from "../../assets/preview.svg";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import popupimage from "../../assets/create-page.png";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import iicon from "../../assets/i.svg";
import Loader from "../Loader/Loader";
import { RegEx } from "../../Utils/RegEx";
import { UpdateStatus } from "./../API/Coupons/UpdateStatus";
import { PagesLisitng } from "../API/MarketPlaceSetUp/PagesListing";
import { DeletePages } from "./../API/MarketPlaceSetUp/DeletePage";
import { SavePages } from "../API/MarketPlaceSetUp/SavePages";
import swal from "sweetalert";
import { SaveEditPages } from "../API/MarketPlaceSetUp/EditPages";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

export const Pages = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showedit, setshowedit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [ShowTable, setShowTable] = useState(false);
  const [globalTableRows, setglobalTableRows] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // AutoPublish
  const [AutoPublish, setAutoPublish] = useState([]);
  const [checkAutoPublish, setcheckAutoPublish] = useState(false);

  // popup - create
  // feild
  const [PageName, setPageName] = useState("");
  const [PageUrl, setPageUrl] = useState("");
  const [PageId, setPageId] = useState(0);
  // feild--Err
  const [PageNameErr, setPageNameErr] = useState("");
  const [PageUrlErr, setPageUrlErr] = useState("");

  // search
  const [search, setSearch] = useState("");

  // sort
  const [flag, setFlag] = useState({
    page_name: 0,
  });

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setPageUrlErr("");
    setPageNameErr("");
    if (pageCount < 10) {
      setPageUrl("");
      setPageName("");
      setShow(true);
    } else {
      swal({
        text: "Max 5 pages can be listed down under navigation but you can create upto 10 pages and switch between the pages when required",
        icon: "warning",
        buttons: "Ok",
      });
    }
  };

  const handleCloseEdit = () => setshowedit(false);
  const handleShowEdit = () => setshowedit(true);

  useEffect(() => {
    setLoading(true);
    ApiLoad();
  }, []);

  const ApiLoad = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const coupondetailData = await PagesLisitng(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData.data.length == 0) {
      setShowTable(true);
    } else if (coupondetailData.staus === 429) {
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
      });
      setLoading(true);
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setPageCount(coupondetailData.page_count);
      setglobalTableRows(coupondetailData.data);
    }
  };

  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(TableRows.map((li) => li.page_id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].page_id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== TableRows[key].page_id));
    }
  };

  const handleChangeDropDownTop = (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      coupon_id: isCheck,
      status_id: parseInt(e.target.value),
    };
    const coupondetailData = UpdateStatus(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData, "coupondetailData");
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
    setLoading(false);
  };

  // Delete
  const handleDelete = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      // page_option: "",
      page_id: isCheck,
    };
    swal({
      title: `Are you sure you want to delete selected pages?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const coupondetailData = await DeletePages(data, () => {
          navigate("/");
        });
        if (coupondetailData.status === 429) {
          swal({
            text: `${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
          setLoading(true);
        } else {
          swal({
            // title: "Success!",
            title: `selected pages has been deleted successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then(() => {
            window.location.reload(false).then(() => {
              setIsCheck([]);
              setShowTable(false);
              setTableRows(coupondetailData?.data);
              setLoading(false);
            });
            // setTimeout(() => {

            // }, 500);
          });
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        }).then(() => {
          window.location.reload(false);
        });
      }
    });
    setLoading(false);
  };

  const handleDeleteEach = async (e, key) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      // page_option: TableRows[key].page_type,
      page_id: [TableRows[key].page_id],
    };
    // const coupondetailData = await DeletePages(data);
    // console.log(coupondetailData,"coupondetailData")

    swal({
      title: `Are you sure you want to delete ${TableRows[key].page_name}?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const Response = await DeletePages(data, () => {
          navigate("/");
        });
        if (Response === false) {
          setLoading(false);
          swal({
            text: `Internal Server Error!`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
        } else {
          if (Response.status === 429) {
            swal({
              text: `${Response.message}`,
              icon: "error",
              buttons: "Ok",
            });
            setLoading(true);
          } else if (Response.status == 400) {
            setLoading(false);
            swal({
              text: `${Response.message}`,
              icon: "warning",
              buttons: "Ok",
              dangerMode: false,
            });
            swal.stopLoading();
            swal.close();
          } else {
            swal({
              title: `${TableRows[key].page_name} has been deleted successfully!`,
              icon: "success",
              buttons: "Ok",
            }).then(() => {
              window.location.reload(false).then(() => {
                setIsCheck([]);
                setShowTable(false);
                setTableRows(Response?.data);
                setLoading(false);
              });
              // setTimeout(() => {}, 500);
            });
          }
        }
      }
    });
  };

  const handleAutoPublish = (value) => {
    // console.log(value,"value")
    setcheckAutoPublish(!checkAutoPublish);
    if (value === false) {
      setAutoPublish([]);
    } else {
      setAutoPublish(TableRows.map((li) => li.page_id));
    }
  };

  // const createPage=()=>{
  //   navigate('/marketplace-setup/pages/create_page')
  // }

  const handleEdit = (e, key) => {
    //  console.log(TableRows[key],"hhh")
    if (TableRows[key].page_type == "external") {
      setPageName(TableRows[key].page_name);
      setPageUrl(TableRows[key].page_external_url);
      setPageId(TableRows[key].page_id);
      handleShowEdit();
    }
    if (TableRows[key].page_type == "internal") {
      navigate(
        `/marketplace-setup/pages/edit-page/id=${TableRows[key].page_id}`
      );
    }
  };

  // create newpage - popup
  const onChangeHandler = (fieldName, value) => {
    if (fieldName === "PageName") {
      setPageName(value);
      const str = value.split(" ").join("");
      console.log(str, "kk", str.length);
      if (value.length == 0) {
        setPageNameErr("*Please Enter Page Name");
      } else if (str.length > 20) {
        setPageNameErr("*Character limit exceeded!");
      } else {
        setPageNameErr("");
      }
    } else if (fieldName === "PageUrl") {
      setPageUrl(value.trim());
      let re = RegEx.url;
      if (!re.test(value)) {
        setPageUrlErr("*Please Enter Valid Page Url");
      } else {
        setPageUrlErr("");
      }
    }
  };
  // submit-save

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (PageName.length === 0) {
      setPageNameErr("* Please Enter Page Name");
    }
    if (PageUrl.length === 0) {
      setPageUrlErr("* Please Enter Page Url");
    }
    if (
      PageNameErr.length == 0 &&
      PageUrlErr.length == 0 &&
      PageName.length != 0 &&
      PageUrl.length != 0
    ) {
      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        page_name: PageName,
        internal_url: "",
        page_option: "external",
        external_url: PageUrl,
        page_title: "",
        meta_description: "",
        page_image: "",
        page_content: "",
      };
      setLoading(true);
      const Response = await SavePages(data, () => {
        navigate("/");
      });
      if (Response.status === 429) {
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
        });
        setLoading(true);
      } else if (Response === false) {
        setLoading(false);
        swal({
          text: "Internal Server Error!",
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
      } else {
        if (Response.status == 400) {
          setLoading(false);
          swal({
            text: `${Response.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
          // setLoading(false);
          swal.stopLoading();
          swal.close();
        } else {
          swal({
            // title: "Success!",
            title: `${Response.message}`,
            icon: "success",
            buttons: "Ok",
            dangerMode: false,
          }).then(() => {
            window.location.reload(false).then(() => {
              setShow(false);
              setShowTable(false);
              setPageName("");
              setPageUrl("");
              swal.stopLoading();
              swal.close();
              setTableRows(Response?.data);
              setLoading(false);
            });
            // setTimeout(() => {
            //   setLoading(false);
            // }, 1000);
          });
        }
      }
    }
  };

  // edit
  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    if (PageName.length === 0) {
      setPageNameErr("* Please Enter Page Name");
    }
    if (PageUrl.length === 0) {
      setPageUrlErr("* Please Enter Page Url");
    }
    if (
      PageNameErr.length == 0 &&
      PageUrlErr.length == 0 &&
      PageName.length != 0 &&
      PageUrl.length != 0
    ) {
      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        page_id: [PageId],
        page_name: PageName,
        internal_url: "",
        page_option: "external",
        external_url: PageUrl,
        page_title: "",
        meta_description: "",
        page_image: "",
        page_content: "",
      };
      setLoading(true);
      const Response = await SaveEditPages(data, () => {
        navigate("/");
      });

      setShow(false);
      setShowTable(false);
      setPageName("");
      setPageUrl("");
      if (Response === false) {
        setLoading(false);
        swal({
          text: `Internal Server Error!`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
        swal.stopLoading();
        swal.close();
      } else {
        if (Response.success == false) {
          setLoading(true);
          swal({
            text: `${Response.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
        } else if (Response.success === true) {
          swal({
            // title: "Success!",
            title: `${Response.message}`,
            icon: "success",
            buttons: "Ok",
            dangerMode: false,
          }).then(() => {
            handleCloseEdit();
            swal.stopLoading();
            swal.close();
            setTableRows(Response?.data);
            window.location.reload(false);
            setTimeout(() => {
              setLoading(false);
            }, 1000);
          });
        } else {
        }
      }
    }
  };

  // search
  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = () => {
    if (search.length === 0) {
      setTableRows(globalTableRows);
      setShowTable(false);
    } else {
      const filteredData = TableRows.filter((data) =>
        data.page_name.toLowerCase().startsWith(search)
      );
      console.log(filteredData, "filterd13");
      if (filteredData.length == 0) {
        setShowTable(true);
      } else {
        setTableRows(filteredData);
      }
      // setTableRows(filteredData);
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };

  // sort
  const HandleSortCol = () => {
    if (flag.page_name === 0) {
      handleSort(1);
      setFlag((item) => {
        return { ...item, page_name: 1 };
      });
    } else if (flag.page_name === 1) {
      handleSort(2);
      setFlag((item) => {
        return { ...item, page_name: 2 };
      });
    } else {
      handleSort(0);
      setFlag((item) => {
        return { ...item, page_name: 0 };
      });
    }
  };

  const handleSort = (sortId) => {
    // 1-desc
    if (sortId == 1) {
      const desc = [...TableRows].sort((a, b) =>
        b.page_name.localeCompare(a.page_name)
      );
      console.log(desc, "desc");
      setTableRows(desc);
    }

    if (sortId == 2) {
      const asc = [...TableRows].sort((a, b) =>
        a.page_name.localeCompare(b.page_name)
      );
      console.log(asc, "asc");
      setTableRows(asc);
    }

    if (sortId == 0) {
      console.log("default");
      setTableRows(globalTableRows);
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3">
        <div className="d-flex">
          <p className="page-maintitle pt-1">Pages</p>
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                    data-placement="top"
                  >
                    You can create up to 10 new pages here. Out of 10 you can
                    select maximum 4 pages to link it to the main navigation.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px"></Image>
              </OverlayTrigger>
            ))}
          </div>
        </div>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              autoComplete="off"
              className="search_feild"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
          <Button
            variant="primary"
            className="create-btn export-btn-main"
            onClick={handleShow}
          >
            + Create Page
          </Button>

          {/* popup for create page */}
          <Modal
            show={show}
            onHide={handleClose}
            size="xs"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="popup-modal w-500 CreatePagePopUp"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="mb-5 PagePopUpBody">
              <Image className="pagesImage" src={popupimage} />

              <p className="page-maintitle text-center">
                Link your existing page here
              </p>
              <Row>
                <Col md="2"></Col>
                <Col md="8">
                  <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4">
                    <Row>
                      <Col md="12" className="">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="form-label-custom">
                            Page URL <span className="star-required">* </span>
                            {["top"].map((placement) => (
                              <OverlayTrigger
                                // trigger={"click"}
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-${placement}`}
                                    className="Tooltips"
                                    style={{ opacity: "1" }}
                                  >
                                    This is the page URL of any existing page
                                    (external URL) that you want to link in the
                                    menu of your marketplace instead of creating
                                    the new page.
                                  </Tooltip>
                                }
                              >
                                <Image
                                  src={iicon}
                                  className="mb-1"
                                  width="15px"
                                ></Image>
                              </OverlayTrigger>
                            ))}
                          </Form.Label>

                          <InputGroup className="edit-border">
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder="Page URL"
                              className="custom-formcontrol"
                              value={PageUrl}
                              maxLength={70}
                              onChange={(e) => {
                                onChangeHandler("PageUrl", e.target.value);
                              }}
                            />
                          </InputGroup>
                          {PageUrlErr && (
                            <p className="text-danger">{PageUrlErr}</p>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md="12" className="">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="form-label-custom">
                            Page Name <span className="star-required">* </span>
                          </Form.Label>
                          <InputGroup className="edit-border">
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder="Page Name"
                              className="custom-formcontrol"
                              value={PageName}
                              maxLength={20}
                              onChange={(e) => {
                                onChangeHandler("PageName", e.target.value);
                              }}
                            />
                          </InputGroup>
                          {PageNameErr && (
                            <p className="text-danger">{PageNameErr}</p>
                          )}
                          <p className="max-char">
                            (Maximum characters allowed: 20)
                          </p>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="text-center d-flex">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn mt-3"
                        onClick={(e) => handleSubmit(e)}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                  <p class="loginwith-orange">
                    <span>Or</span>
                  </p>
                  <div className="create-page-btn px-2">
                    <Link to="/marketplace-setup/pages/create-page">
                      <p className="view">Create New Page</p>
                    </Link>
                  </div>
                </Col>
                <Col md="2"></Col>
              </Row>
            </Modal.Body>
          </Modal>

          {/* edit-popup-external */}
          <Modal
            show={showedit}
            onHide={handleCloseEdit}
            size="xs"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="popup-modal w-500"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="mb-5">
              <p className="text-center mb-3">
                <Image src={popupimage} />
              </p>
              <p className="page-maintitle text-center">Edit your page here</p>
              <Row>
                <Col md="2"></Col>
                <Col md="8">
                  <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4">
                    <Row>
                      <Col md="12" className="">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="form-label-custom">
                            Page URL <span className="star-required">*</span>
                            {["top"].map((placement) => (
                              <OverlayTrigger
                                // trigger={"click"}
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-${placement}`}
                                    className="Tooltips"
                                    style={{ opacity: "1" }}
                                  >
                                    This is the page URL of any existing page
                                    (external URL) that you want to link in the
                                    menu of your marketplace instead of creating
                                    the new page.
                                  </Tooltip>
                                }
                              >
                                <Image
                                  src={iicon}
                                  className="mb-1"
                                  width="15px"
                                ></Image>
                              </OverlayTrigger>
                            ))}
                          </Form.Label>

                          <InputGroup className="edit-border">
                            <Form.Control
                              type="text"
                              placeholder="Page URL"
                              className="custom-formcontrol"
                              value={PageUrl}
                              onChange={(e) => {
                                onChangeHandler("PageUrl", e.target.value);
                              }}
                            />
                          </InputGroup>
                          {PageUrlErr && (
                            <p className="text-danger">{PageUrlErr}</p>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md="12" className="">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="form-label-custom">
                            Page Name <span className="star-required">* </span>
                          </Form.Label>
                          <InputGroup className="edit-border">
                            <Form.Control
                              type="text"
                              placeholder="Page Name"
                              className="custom-formcontrol"
                              value={PageName}
                              maxLength={20}
                              onChange={(e) => {
                                onChangeHandler("PageName", e.target.value);
                              }}
                            />
                          </InputGroup>
                          {PageNameErr && (
                            <p className="text-danger">{PageNameErr}</p>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="text-center d-flex">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn mt-3"
                        onClick={(e) => handleSubmitEdit(e)}
                      >
                        Update
                      </Button>
                    </div>
                  </Form>
                </Col>
                <Col md="2"></Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <SearchBarResults SearchValue={search} />
      {isCheck.length != 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3 del_btn"
            onClick={handleDelete}
          >
            Delete Selected
          </Button>
          <Form.Select
            aria-label="Default select example"
            className="table-select width-150 ml-3 status_select"
            onChange={handleChangeDropDownTop}
            style={{ display: "none" }}
          >
            <option>Select Status</option>
            <option value="1">New</option>
            <option value="2">In Review</option>
            <option value="3">Published</option>
            <option value="4">Declined</option>
          </Form.Select>
        </div>
      ) : (
        ""
      )}

      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table pages-table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="option 1"
                  className="orange-checkbox"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
              </th>
              <th onClick={HandleSortCol} style={{ textAlign: "left" }}>
                Page Name
                {flag.page_name === 0 ? (
                  <FaSort></FaSort>
                ) : flag.page_name === 1 ? (
                  <FaSortUp></FaSortUp>
                ) : (
                  <FaSortDown></FaSortDown>
                )}
              </th>
              <th>Created Date</th>
              <th>Page Type</th>
              <th className="action-min-main" style={{ textAlign: "center" }}>
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {ShowTable == false ? (
              <>
                {TableRows?.map((item, key) => {
                  return (
                    <tr>
                      <td className="radio-colors">
                        <Form.Check
                          aria-label="option 1"
                          className="orange-checkbox"
                          onChange={(e) => handleClick(e, key)}
                          checked={isCheck.includes(item.page_id)}
                        />
                      </td>

                      <td style={{ textAlign: "left" }}>{item.page_name}</td>
                      <td>{FormatDateShortMonth(item.created_at)}</td>
                      <td>{item.page_type}</td>
                      <td>
                        <div
                          className="action-min-img"
                          style={{ justifyContent: "center", gap: "10px" }}
                        >
                          {item.page_type == "external" ? (
                            <a
                              target="_blank"
                              href={
                                item?.page_external_url?.startsWith("http")
                                  ? item.page_external_url
                                  : `${"https://" + item.page_external_url}`
                              }
                            >
                              <Image src={Preview}></Image>
                            </a>
                          ) : (
                            <Link
                              to={`/marketplace-setup/pages/view-page/id=${item.page_id}`}
                            >
                              <Image src={Preview}></Image>
                            </Link>
                          )}

                          <div>
                            <Image
                              src={editpic}
                              onClick={(e) => handleEdit(e, key)}
                              title="Edit"
                            ></Image>
                          </div>
                          <Link>
                            <Image
                              src={deletepic}
                              onClick={(e) => handleDeleteEach(e, key)}
                              title="Delete"
                            ></Image>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
